import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { checkNameShowHide, nameMask } from "../../utils/utils";

function RightPanel({ onFilterChange, matchList, matchType, planDetailUser }) {
  const navigate = useNavigate();

  
  const handleChatClick = (e, user) => {
  e.preventDefault();

  if (!user?._id) return;

  if (!planDetailUser || planDetailUser?.plan_id === '6913323a5be8a54eb6b4ab7a') {
    navigate('/membership-plan');
    return;
  }

  if (user?.profileSettings?.chat_disabled) {
    alert('Chat is disabled for this partner');
    return;
  }

    if (user?.status === 'Accepted') {
      navigate(`/chat-box/${user._id}`);
    } else {
      navigate(`/profile-details/${user._id}`);
    }
  };
  

  return (
    <div className="profilelist-rightpanle">
      <select
        className="form-select-new"
        onChange={(e) => onFilterChange(e.target.value)}
      >
        <option value="shortlist">Shortlist & More</option>
        <option value="accepted">Accepted Members</option>
      </select>

      <hr />

      {Array.isArray(matchList) && matchList.length > 0 ? (
        matchList.map((member, index) => {

          const user =
            matchType === "shortlist"
              ? member?.partner_id
              : member?.partner_id;

          if (!user) return null;


          return (
            <div className="chatrow mb-2" key={user?._id || index}>
              <Link to="#" onClick={(e) => handleChatClick(e, user)}>
                <div style={{ width: "30px", height: "30px", borderRadius: "10%", border: "1px solid #ccc", overflow: "hidden" }}>
                  <img
                    src={user?.photo ? `${process.env.REACT_APP_BASE_URL_IMAGE}${user?.photo}` : user.gender === 'Male' ? 'assets/img/no-image-male.jpg' : 'assets/img/no-image-female.jpg'}
                    alt=""
                  />
                </div>

                <span>
                  {checkNameShowHide(user?.profileSettings?.name_show, planDetailUser) ? user?.name : nameMask(user?.name)}{" "}
                </span>


                <img
                  src="assets/img/icons/verified.png"
                  alt="verified"
                />

              </Link>
            </div>
          );
        })
      ) : (
        <p className="text-center">No members found</p>
      )}
    </div>
  );
}

export default RightPanel;
